import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { AdminTitle } from "./AdminLayout";
import { http, formatDateTime } from "../../lib/api";

const state = (s) => {
  if (s.status === "failed") return ["Failed", "text-rose-300"];
  if (s.revoked_at) return [s.revoke_reason || "Revoked", "text-slate-400"];
  if (new Date(s.expires_at) <= new Date()) return ["Expired", "text-slate-400"];
  return ["Active", "text-emerald-300"];
};

export default function SharedPdfs() {
  const { data, isLoading } = useQuery({ queryKey: ["admin-shares"], queryFn: async () => (await http.get("/admin/shares")).data });
  const items = Array.isArray(data?.items) ? data.items : [];
  return (
    <div data-testid="shared-pdfs">
      <AdminTitle title="Shared PDFs" sub="Every Shareable PDF emailed to a customer: who sent it, when, to whom, and whether the link is still active." />
      {isLoading ? <Loader2 className="w-6 h-6 animate-spin text-gold" /> : !items.length ? (
        <p className="border border-dashed border-white/20 p-12 text-center text-slate-300" data-testid="shared-pdfs-empty">No PDFs have been emailed yet.</p>
      ) : (
        <div className="overflow-x-auto border hairline">
          <table className="w-full text-sm min-w-[760px]">
            <thead className="bg-[var(--ink-2)]"><tr className="text-left text-xs uppercase tracking-wider text-slate-400">
              {["Sent", "Inquiry", "Recipient", "Sent by", "Email status", "Link", "Opened"].map((h) => <th key={h} className="p-3 font-normal">{h}</th>)}
            </tr></thead>
            <tbody className="divide-y divide-white/10">
              {items.map((s) => {
                const [label, cls] = state(s);
                return (
                  <tr key={s.id} data-testid={`shared-row-${s.id}`}>
                    <td className="p-3 whitespace-nowrap">{formatDateTime(s.sent_at || s.created_at)}</td>
                    <td className="p-3"><Link to={`/admin/inquiries?id=${s.inquiry_id}`} className="text-gold hover:underline font-mono text-xs">{s.ref}</Link><span className="block text-xs text-slate-400">{s.customer_name}</span></td>
                    <td className="p-3 break-all">{s.recipient}</td>
                    <td className="p-3">{s.sent_by}<span className="block text-xs text-slate-400 capitalize">{s.sent_by_role}</span></td>
                    <td className={`p-3 ${s.status === "sent" ? "text-emerald-300" : s.status === "failed" ? "text-rose-300" : ""}`}>{s.status === "sent" ? "Sent to provider" : s.status === "failed" ? `Failed${s.error ? ` (${s.error})` : ""}` : "Sending"}</td>
                    <td className="p-3"><span className={cls}>{label}</span>{s.status === "sent" && <span className="block text-xs text-slate-400">until {formatDateTime(s.expires_at)}</span>}</td>
                    <td className="p-3">{s.download_count || 0}×{s.last_downloaded_at && <span className="block text-xs text-slate-400">{formatDateTime(s.last_downloaded_at)}</span>}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
